import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useScroll } from '@/src/components/global/ScrollContext';
function getDocumentTop(element) {
  const rect = element.getBoundingClientRect();
  return window.scrollY + rect.top;
}
export function useRevealOnScroll(options) {
  const $ = _c(14);
  const {
    targetRef,
    staticThreshold,
    margin: t0,
    enabled: t1
  } = options;
  const margin = t0 === undefined ? 0 : t0;
  const enabled = t1 === undefined ? true : t1;
  const {
    scrollY
  } = useScroll();
  const [threshold, setThreshold] = useState(staticThreshold ?? 0);
  const resizeObserverRef = useRef(null);
  targetRef?.current;
  let t2;
  t2 = enabled && !staticThreshold && !!targetRef?.current;
  const canMeasure = t2;
  let t3;
  if ($[0] !== enabled || $[1] !== margin || $[2] !== staticThreshold || $[3] !== targetRef?.current) {
    t3 = () => {
      if (!enabled) {
        return;
      }
      const el = targetRef?.current || null;
      if (staticThreshold != null) {
        setThreshold(staticThreshold - margin);
        return;
      }
      if (!el) {
        return;
      }
      const measure = () => {
        const top = getDocumentTop(el);
        setThreshold(top - margin);
      };
      measure();
      if ("ResizeObserver" in window) {
        resizeObserverRef.current?.disconnect();
        resizeObserverRef.current = new ResizeObserver(() => {
          measure();
        });
        resizeObserverRef.current.observe(el);
      }
      window.addEventListener("resize", measure);
      return () => {
        window.removeEventListener("resize", measure);
        resizeObserverRef.current?.disconnect();
        resizeObserverRef.current = null;
      };
    };
    $[0] = enabled;
    $[1] = margin;
    $[2] = staticThreshold;
    $[3] = targetRef?.current;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== canMeasure || $[6] !== enabled || $[7] !== margin || $[8] !== staticThreshold || $[9] !== targetRef) {
    t4 = [enabled, targetRef, staticThreshold, margin, canMeasure];
    $[5] = canMeasure;
    $[6] = enabled;
    $[7] = margin;
    $[8] = staticThreshold;
    $[9] = targetRef;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  const isRevealed = enabled ? scrollY >= threshold : true;
  let t5;
  if ($[11] !== isRevealed || $[12] !== threshold) {
    t5 = {
      isRevealed,
      threshold
    };
    $[11] = isRevealed;
    $[12] = threshold;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}